export const WIZARD_COOKIES_KEY = 'wizard-cookies'
